
/**
 * @author Thiago Neri
 * @version $Id$
 */
export class DataPackSelectItem {

  public id: string;
  public description: string;
  public memberInfo: string;

  public constructor() {

  }
}




// WEBPACK FOOTER //
// ./src/app/models/DataPackSelectItem.model.ts